import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Card, Flex, Typography } from 'antd'
import { path } from 'src/libs'
import { CommissionListSection } from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/section'

export const ReportCommissions = () => {
  const navigate = useNavigate()
  const { Title, Text } = Typography

  return (
    <Flex vertical gap="middle">
      <Breadcrumb
        items={[
          {
            title: (
              <Text
                style={{
                  cursor: 'pointer',
                  color: 'var(--color-primary)',
                  fontSize: 16,
                }}
                onClick={() => navigate(path.finSystem.balanceSummary.entry())}
              >
                Financial statement
              </Text>
            ),
          },
          {
            title: (
              <Text type="secondary" style={{ fontSize: 16 }}>
                Transaction commissions
              </Text>
            ),
          },
        ]}
      />
      <Title level={1} style={{ marginBottom: 0 }}>
        Transaction commissions
      </Title>
      <Card>
        <CommissionListSection />
      </Card>
    </Flex>
  )
}
